import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { OrderPartialErrorService } from '../services/order-partial-error.service';

@Injectable({
  providedIn: 'root',
})
export class OrderPartialErrorGuard implements CanActivate {
  private router = inject(Router);
  private orderPartialErrorService = inject(OrderPartialErrorService);


  canActivate(): boolean {
    if (this.orderPartialErrorService.hasPartialError()) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
